import { methodGet, methodDelete, methodPut, methodPost, methodPatch } from './methods';
import { API_INFO } from '../constants';

export async function getAllBooksToSelectComponent() {
  const url = API_INFO + `books/books/`;
  return methodGet(url);
}

export async function getBooksByLanguages(query) {
  const url = API_INFO + `books/books/`;
  return methodGet(url, query);
}

export const getBookBindings = async (payload) => {
  return methodGet(API_INFO + 'books/books/bookbinding/', payload);
};

export async function getAllEbooks(query) {
  const url = API_INFO + `books/books/ebooks/`;
  return methodGet(url, query);
}

export async function listEncuadernacion(slug) {
  const url = API_INFO + `books/books/bookbinding/${slug}`;
  return methodGet(url, {});
}

export async function getMaterias(slug) {
  const url = API_INFO + `books/materias-cervantes/${slug}`;
  return methodGet(url, {});
}

export async function listLanguages(query) {
  const url = API_INFO + 'books/books/languages/';
  return methodGet(url, query);
}

export async function listPaises(query) {
  const url = API_INFO + 'books/books/countries/';
  return methodGet(url, query);
}

export const getMateriasByCompany = () => {
  const url = API_INFO + 'books/materias/main-materies/';
  return methodGet(url);
};

export const detailMateryGeslibApi = (payload) => {
  const url = API_INFO + 'books/materias-geslib/';
  return methodGet(url, payload);
};

export const getDetailMateryGeslib = (slug) => {
  const url = API_INFO + 'books/materias-geslib/';
  return methodGet(url, slug);
};

export const getDetailMateryIbic = (slug) => {
  const url = API_INFO + 'books/materias-ibic/';
  return methodGet(url, slug);
};

export const getElementsMateryGeslib = (slug, query) => {
  const url = API_INFO + `books/materias-geslib/${slug}/get-products/`;
  return methodGet(url, query);
};

export const getElementsMateryIbic = (slug, query) => {
  const url = API_INFO + `books/materias-ibic/${slug}/get-products/`;
  return methodGet(url, query);
};

export const featuredMattersGeslibApi = () => {
  const url = API_INFO + 'books/materias-geslib/featured-matters';
  return methodGet(url);
};

export async function getAwardedBooks(query) {
  const url = API_INFO + `books/literary-awards/`;
  return methodGet(url, query);
}
export async function getAwardedBook(id) {
  const url = API_INFO + `books/literary-awards/${id}/`;
  return methodGet(url);
}
export async function deleteAwardedBook(id) {
  const url = API_INFO + `books/literary-awards/${id}/`;
  return methodDelete(url);
}
export async function editAwardedBook(id, payload) {
  const url = API_INFO + `books/literary-awards/${id}/`;
  return methodPut(url, payload);
}
export async function createAwardedBook(payload) {
  const url = API_INFO + `books/literary-awards/`;
  return methodPost(url, payload);
}

export async function getSmallReviews() {
  const url = API_INFO + 'books/books/small-reviews/';
  return methodGet(url);
}

export async function getSmallReviewsDetail(query) {
  const url = API_INFO + `books/books/small-reviews-detail/`;
  return methodGet(url, query);
}

export async function getBookDetail(id) {
  const url = API_INFO + `books/books/${id}/`;
  return methodGet(url, {});
}
export async function deleteBook(id) {
  const url = API_INFO + `books/books/${id}/`;
  return methodDelete(url);
}
export async function editBookDetail(id, payload) {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  const url = API_INFO + `books/books/${id}/`;
  return methodPatch(url, payload, config);
}
export async function createBook(payload) {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  const url = API_INFO + `books/books/`;
  return methodPost(url, payload, config);
}

export async function getBookAvailableLibraries(id) {
  const url = API_INFO + `books/books/${id}/available-libraries/`;
  return methodGet(url, {});
}

export async function getAllBooks(query) {
  const url = API_INFO + `libros/libros/`;
  return methodGet(url, query);
}

export async function getMateriasIbic() {
  const url = API_INFO + `libros/materias-ibic/all-materies/`;
  return methodGet(url, {});
}

export async function putListOfBook(id, payload) {
  const url = API_INFO + `libros/libros/${id}/`;
  return methodPut(url, payload);
}

export async function getRecommendedBooks() {
  const url = API_INFO + `books/books/?is_recommended=true`;
  return methodGet(url);
}

export async function saveRecommendBookstores(payload) {
  const url = API_INFO + `books/books/recommended-books-true-or-false-by-id/`;
  return methodPatch(url, payload);
}
